document.addEventListener('DOMContentLoaded', () => {
    const tables = document.querySelectorAll('.table')
    const viewportHeight = window.innerHeight
    const navBarHeight = 74
    
    tables?.forEach(table => {
        const th = table.querySelectorAll('thead th');
        th?.forEach(el => {
            el.style.marginBottom = `${viewportHeight - navBarHeight - 150}px`;
        })
    })
    

});